import { SET_RECORD_PAYMENT_RESPONSE } from '../actions/recordPaymentActions';

const initialState = null

const recordPaymentReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_RECORD_PAYMENT_RESPONSE:
        return action.payload;
      default:
        return state;
    }
  };
  
  export default recordPaymentReducer;
  